// Anti-abus usage anonyme (Phase D) — 100% navigateur.
// - Session anonyme : identifiant aléatoire >=128 bits (Web Crypto), persistée en localStorage
//   avec repli mémoire. Jamais Math.random. Sert de second signal anti-abus (avec l'IP côté backend).
// - Jeton de récupération : 256 bits ; seul son SHA-256 est transmis à la création.
import { b64urlEncode } from "./crypto";

const SESSION_KEY = "securepass_anonymous_session";
export const ANON_SESSION_HEADER = "X-SecurePass-Anonymous-Session";

let _memSession = null;

function _newId() {
  // 24 octets = 192 bits -> 32 caractères base64url (format attendu par le backend).
  const bytes = window.crypto.getRandomValues(new Uint8Array(24));
  return b64urlEncode(bytes);
}

export function getAnonymousSessionId() {
  if (_memSession) return _memSession;
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = _newId();
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch (e) {
    // localStorage indisponible : session en mémoire pour la session courante.
    _memSession = _newId();
    return _memSession;
  }
}

// Jeton de récupération anonyme : le token en clair reste dans le lien privé du demandeur.
// Seul tokenHash = base64url(SHA-256(token)) est envoyé au backend à la création.
export async function generateRecoveryToken() {
  const bytes = window.crypto.getRandomValues(new Uint8Array(32)); // 256 bits
  const token = b64urlEncode(bytes);
  const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(token));
  return { token, tokenHash: b64urlEncode(digest) };
}
